import _ from "lodash";
import type { PatchedAdminRecruitingInfo } from "@/api/model";
import { emptyOrBlank } from "./emptyOrBlank";
import * as formatters from "@/modules/profile/utils/formatters";
import type { RecruitingInfoFormRows } from "../components/sections";

export class CollapsableRecruitingInfoPatchDTO
  implements PatchedAdminRecruitingInfo
{
  gpa?: PatchedAdminRecruitingInfo["gpa"];
  sat_score?: PatchedAdminRecruitingInfo["sat_score"];
  act_score?: PatchedAdminRecruitingInfo["act_score"];
  ncaa_eligibility_center_id?: PatchedAdminRecruitingInfo["ncaa_eligibility_center_id"];
  college_commitment?: PatchedAdminRecruitingInfo["college_commitment"];
  highlights_recruiting_profile_link?: PatchedAdminRecruitingInfo["highlights_recruiting_profile_link"];

  constructor(data: PatchedAdminRecruitingInfo) {
    this.gpa = data.gpa;
    this.sat_score = data.sat_score;
    this.act_score = data.act_score;
    this.ncaa_eligibility_center_id = data.ncaa_eligibility_center_id;
    this.college_commitment = data.college_commitment;
    this.highlights_recruiting_profile_link =
      data.highlights_recruiting_profile_link;
  }

  toJSON(): PatchedAdminRecruitingInfo {
    return _.omitBy(this, emptyOrBlank);
  }
}

export const recruitingInfoToViewModel = (
  requestModel: PatchedAdminRecruitingInfo | null | undefined
): RecruitingInfoFormRows => ({
  gpa: {
    label: "GPA",
    data: requestModel?.gpa,
    lastUpdated: formatters.formatDisplayDate(requestModel?.gpa_updated_at),
  },
  satScore: {
    label: "SAT Score",
    data: requestModel?.sat_score,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.sat_score_updated_at
    ),
  },
  actScore: {
    label: "ACT Score",
    data: requestModel?.act_score,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.act_score_updated_at
    ),
  },
  ncaaEligibilityCenterId: {
    label: "NCAA Eligibility Center ID",
    data: requestModel?.ncaa_eligibility_center_id,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.ncaa_eligibility_center_id_updated_at
    ),
  },
  collegeCommitment: {
    label: "College Commitment",
    data: requestModel?.college_commitment,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.college_commitment_updated_at
    ),
  },
  highlightsRecruitingProfileLink: {
    label: "Highlights/Recruiting Profile Link",
    data: requestModel?.highlights_recruiting_profile_link,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.highlights_recruiting_profile_link_updated_at
    ),
  },
});
